import React, {useEffect, useState} from 'react'
import {Box, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import MeasureUnitService from 'services/MeasureUnitService';
import OtherCriteriaFields from './components/OtherCriteriaFields';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import Select from 'components/Select';
import ListVariantCriteriaList from './listVariant/CriteriaList';
import AllocationVariantCriteriaList from './intervalVariant/CriteriaList';
import PartsTable from 'components/PartsTable';
import {CriterionDictionaryItems, PriceCriterionDictionaryItems} from 'constants/DirectionsItems';
import UploadFile from 'components/UploadFile';
import {VARIANT_CODE as CRITERIA_TYPE} from './constants/criteria.variants'
import {VALUES as TABS_VALUES} from './constants/tabs.values'
import {CRYTERIUM_TYPE} from './constants/criterium.type';
import INPUT_TYPE from "constants/INPUT_TYPE";
import Loading from "components/Loading";
import {connect} from "react-redux";
import {isDemandPreparing} from "libs/getDemandStatus";

const style = theme => ({
    root: {}
})

function CriteriaFormBody(
    {
        classes,
        formikProps,
        getInitialValues,
        isEdit,
        elementList,
        selectedItems,
        initValues,
        showParts,
        demandHeader
    }) {

    const [measureUnits, setMeasureUnits] = useState(null);

    useEffect(() => {
        MeasureUnitService.getWithEmptyOption().then((resp) => setMeasureUnits(resp));
    }, []);

    const uiType = formikProps.values.uiType;
    const type = formikProps.values.type;

    if (!measureUnits) {
        return (
            <Loading/>
        )
    }

    return (
        <>
            {formikProps.values.tab === TABS_VALUES.NEW &&
            <OtherCriteriaFields
                formikProps={formikProps}
                edit={isEdit}
                selectedItems={selectedItems}
                initValues={initValues}
            />
            }

            <TextInput
                id='weight'
                label={Tr('weight')}
                endAdornment={'%'}
                formikProps={formikProps}
                className={classes.weightInput}
                disabled={type === CRYTERIUM_TYPE.PRICE || (!isDemandPreparing() && !!initValues)}
                type={INPUT_TYPE.NUMBER_19}
                step="0.01"
                required
            />

            {(uiType === CRITERIA_TYPE.LIST
                || uiType === CRITERIA_TYPE.INTERVAL
                || uiType === CRITERIA_TYPE.NUMBER
                || uiType === CRITERIA_TYPE.PRICE) &&
            <>
                {(type !== CRYTERIUM_TYPE.PRICE && uiType !== CRITERIA_TYPE.PRICE) &&
                <Select
                    id='uom'
                    label={Tr('measure_unit')}
                    items={measureUnits}
                    formikProps={formikProps}
                />
                }
                {
                    (uiType === CRITERIA_TYPE.NUMBER || uiType === CRITERIA_TYPE.PRICE) &&
                    <Select
                        id='direction'
                        label={Tr('formula')}
                        items={type === CRYTERIUM_TYPE.PRICE ? PriceCriterionDictionaryItems : CriterionDictionaryItems}
                        formikProps={formikProps}
                        required
                    />
                }
            </>
            }
            {uiType === CRITERIA_TYPE.LIST &&
            <ListVariantCriteriaList
                formikProps={formikProps}
                disabled={!isDemandPreparing() && !!initValues}
            />
            }
            {uiType === CRITERIA_TYPE.INTERVAL &&
            <AllocationVariantCriteriaList
                formikProps={formikProps}
                disabled={!isDemandPreparing() && !!initValues}
            />
            }

            {!!demandHeader && demandHeader.apiVersion < 3 &&
            <Box component="div" className={classes.uploadFile}>
                <UploadFile
                    id="attachments"
                    formikProps={formikProps}
                    label={Tr("attachment")}
                />
            </Box>
            }

            {elementList.length > 1 &&
            <PartsTable
                id={'parts'}
                formikProps={formikProps}
                elementList={elementList}
            />
            }
        </>
    )
}

CriteriaFormBody.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
}))(withStyles(style)(CriteriaFormBody));